module.exports = __webpack_public_path__ + "static/media/expanding_black.476ba9cf.png";